import { Component, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { BarcodeScannerService } from '../../services/barcode-scanner.service';
import { LoggerService } from 'src/app/services/logger.service';
import { PCTableOutputModel } from '../../models/pc-table-input-model';

@Component({
  selector: 'app-barcode-scanner',
  templateUrl: './barcode-scanner.component.html',
  styleUrls: ['./barcode-scanner.component.css']
})
export class BarcodeScannerComponent {
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef<HTMLVideoElement>;
  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  isPopupOpen = false; // Controls modal visibility
  scannedCode: string | null = null;

  constructor(
    private barcodeScannerService: BarcodeScannerService,
    private logger: LoggerService
  ) {}

  /** Opens the popup and starts scanning */
  openPopup() {
    this.isPopupOpen = true;
    setTimeout(() => this.startScanning(), 100); // Wait for modal to render
  }

  /** Starts scanning the barcode */
  async startScanning() {
    if (this.videoElement) {
      try {
        this.scannedCode = await this.barcodeScannerService.scanBarcode(this.videoElement.nativeElement);
        this.scannedCode = this.scannedCode.replace(/[^a-z-A-Z|0-9]/g, '');
        this.barcodeScannerService.stopScanner();
        this.parentAction.emit(new PCTableOutputModel('scanBarcode', this.scannedCode));
        this.closePopup();
      } catch (error) {
        this.logger.addError(error, false);
        this.closePopup();
      }
    }
  }

  closePopup() {
    this.isPopupOpen = false;
    this.barcodeScannerService.stopScanner();
  }
}
